import React from 'react';
import { NavLink } from 'react-router-dom';
import { BASE } from './links';
import './NavSezione.css';

/**
 * La navigazione della sezione statistiche.
 *
 * Prima al suo posto c'era una scia di briciole in cima a ogni pagina ("Statistiche › Squadre ›
 * Ka Haru Patiri"), che faceva due lavori e nessuno bene: diceva dove sei, e permetteva di
 * risalire. Dire dove sei lo fa meglio una linguetta accesa; risalire lo fa già il tasto
 * Indietro. E soprattutto le briciole non permettono l'unica cosa che serve davvero qui, cioè
 * passare da un indice all'altro senza tornare a monte: da Squadre a Giocatori sono due click e
 * un passaggio dall'hub, con la barra è uno.
 *
 * Le linguette restano accese anche sulle pagine di dettaglio: chi guarda la scheda di una
 * squadra vede Squadre acceso e sa da dove è arrivato.
 */
const VOCI = [
  { a: `${BASE}/edizioni`, testo: 'Edizioni' },
  { a: `${BASE}/squadre`, testo: 'Squadre' },
  { a: `${BASE}/giocatori`, testo: 'Giocatori' },
];

/**
 * Le pagine di dettaglio non hanno una linguetta propria: accendono quella dell'indice da cui
 * si arriva. Il confronto è sul prefisso della rotta, non sull'indirizzo esatto.
 */
const PADRI = [
  { prefisso: `${BASE}/squadra/`, indice: `${BASE}/squadre` },
  { prefisso: `${BASE}/giocatore/`, indice: `${BASE}/giocatori` },
  { prefisso: `${BASE}/edizione/`, indice: `${BASE}/edizioni` },
];

export default function NavSezione({ percorso }) {
  const padre = PADRI.find((p) => percorso.startsWith(p.prefisso));

  return (
    <nav className="nav-sezione" aria-label="Sezioni delle statistiche">
      <div className="nav-sezione-interno">
        <NavLink to={BASE} end className="nav-sezione-titolo">Statistiche</NavLink>

        <ul className="nav-sezione-voci">
          {VOCI.map((v) => (
            <li key={v.a}>
              <NavLink
                to={v.a}
                className={({ isActive }) =>
                  `nav-sezione-voce${isActive || padre?.indice === v.a ? ' attiva' : ''}`}
                aria-current={padre?.indice === v.a ? 'true' : undefined}
              >
                {v.testo}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
